import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, ArrowLeft } from "lucide-react";
import { useAuth, formatApiErrorDetail } from "@/context/AuthContext";

const field = "w-full bg-[#121214] border border-white/10 focus:border-[#E53935] outline-none px-4 py-3 text-white placeholder:text-white/30 transition-colors";

export default function AdminLogin() {
  const { login, user } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => { if (user) nav("/admin", { replace: true }); }, [user, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await login(email, password);
      nav("/admin", { replace: true });
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0B] flex items-center justify-center px-6">
      <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
        className="w-full max-w-md">
        <Link to="/" data-testid="back-home" className="inline-flex items-center gap-2 text-white/40 hover:text-white transition-colors mb-10 text-sm">
          <ArrowLeft size={16} /> Back to site
        </Link>
        <div className="flex items-center gap-2 mb-2">
          <span className="w-3 h-3 bg-[#E53935] block" />
          <span className="font-display font-extrabold tracking-tight text-xl">EXON GLOBAL</span>
        </div>
        <h1 className="font-display font-extrabold text-4xl tracking-tighter mb-8">Admin login</h1>
        <form onSubmit={submit} className="space-y-4" data-testid="login-form">
          <input data-testid="login-email" className={field} placeholder="Email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} />
          <input data-testid="login-password" className={field} placeholder="Password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} />
          {error && <p className="text-[#E53935] text-sm" data-testid="login-error">{error}</p>}
          <button type="submit" disabled={loading} data-testid="login-submit"
            className="group w-full inline-flex items-center justify-center gap-3 bg-[#E53935] hover:bg-[#F44336] disabled:opacity-60 text-white font-medium px-8 py-4 transition-colors">
            {loading ? "Signing in…" : "Sign in"}
            {!loading && <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />}
          </button>
        </form>
      </motion.div>
    </div>
  );
}
